export enum Permission {
  ManageServer = 'manage_server',
  ManageChannels = 'manage_channels',
  ManageRoles = 'manage_roles',
  ManageMembers = 'manage_members',
  ManageInvites = 'manage_invites',
  KickMembers = 'kick_members',
  BanMembers = 'ban_members',
  SendMessages = 'send_messages',
  ManageMessages = 'manage_messages',
  EmbedLinks = 'embed_links',
  AttachFiles = 'attach_files',
  MentionEveryone = 'mention_everyone',
  Connect = 'connect',
  Speak = 'speak',
  MuteMembers = 'mute_members',
  DeafenMembers = 'deafen_members',
  MoveMembers = 'move_members',
}

export interface Role {
  id: string
  serverId: string
  name: string
  color: string
  permissions: Permission[]
  position: number
}
